import RegisteredUsers from "./RegisteredUsersContainer";

export default RegisteredUsers;
